import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Phone, Mail, MapPin, Clock } from 'lucide-react';

const OfficeContacts = () => {
  const navigate = useNavigate();

  const offices = [
    {
      name: "Małopolska Provincial Office in Krakow",
      address: "ul. Przy Rondzie 6, 31-547 Kraków",
      phone: "+48 12 39 21 854",
      email: "info.opt@muw.pl",
      hours: "Monday: 7:00 - 18:00, Tuesday - Friday: 7:30 - 15:30",
      helpline: "+48 12 210 20 20"
    },
    {
      name: "Mazowieckie Provincial Office in Warsaw",
      address: "ul. Marszałkowska 3/5, 00-624 Warszawa",
      phone: "+48 22 695 67 00",
      email: "info@mazowieckie.pl",
      hours: "Monday: 10:00 - 18:00, Tuesday - Friday: 8:00 - 16:00",
      helpline: "+48 22 695 67 68"
    },
    {
      name: "Wielkopolska Provincial Office in Poznań",
      address: "pl. Wolności 17, 61-739 Poznań",
      phone: "+48 61 850 87 77",
      email: "wsc@poznan.uw.gov.pl",
      hours: "Monday: 9:30 - 18:00, Tuesday - Friday: 8:15 - 15:15",
      helpline: "+48 61 850 87 77"
    },
    {
      name: "Dolnośląskie Provincial Office in Wrocław",
      address: "pl. Powstańców Warszawy 1, 50-153 Wrocław",
      phone: "+48 71 340 66 55",
      email: "info@duw.pl",
      hours: "Monday: 9:00 - 17:00, Tuesday - Friday: 8:00 - 16:00",
      helpline: "+48 71 340 66 66"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <Users className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Voivodeship Office Contacts
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Contact information for major immigration offices across Poland
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {offices.map((office, index) => (
            <Card key={index} className="hover:shadow-lg transition-all duration-300">
              <CardHeader>
                <CardTitle className="text-xl text-foreground">{office.name}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="h-5 w-5 text-primary mt-1" />
                  <p className="text-muted-foreground">{office.address}</p>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-primary" />
                  <p className="text-muted-foreground">
                    Phone: {office.phone}
                    <br />
                    Helpline: {office.helpline}
                  </p>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-primary" />
                  <p className="text-muted-foreground">{office.email}</p>
                </div>
                <div className="flex items-start space-x-3">
                  <Clock className="h-5 w-5 text-primary mt-1" />
                  <p className="text-muted-foreground">{office.hours}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 bg-card rounded-lg p-6 border border-border">
          <h2 className="text-2xl font-bold text-foreground mb-4">Important Notes</h2>
          <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
            <li>Always check the office's website for the most up-to-date information and any holiday closures</li>
            <li>Some services may require prior appointment booking</li>
            <li>Bring all necessary documents and their translations to your appointment</li>
            <li>Consider peak hours when planning your visit</li>
          </ul>
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base/support-resources')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Support Resources
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfficeContacts; 